// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WebhookLogs_BuscarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /webhook_logs/buscar
 *
 * Query params for filtering the webhook log list.
 */
import { registerContract } from './validate'

export interface WebhookLogs_BuscarInput {
provider?: string
status?: string
limit?: number
}

registerContract('WebhookLogs_BuscarInput', {
  provider: { type: 'string',  required: false },
  status:   { type: 'string',  required: false },
  limit:    { type: 'number',  required: false },
})
